import { gql } from '@apollo/client'

export const BANK_ACCOUNT_FRAGMENT = gql`
    fragment FullBankAccount on CheckbookAccount {
        id
        userId
        type
        email
        holder
        name
        accountNumber
        routingNumber
        ownedByUser
        institution {
            logo
            name
        }
    }
`

gql`
    query BankAccounts {
        bankAccounts {
            ...FullBankAccount
        }
    }
    ${BANK_ACCOUNT_FRAGMENT}
`

gql`
    query LookupInstitution($routingNumber: String!) {
        achInstitution(routingNumber: $routingNumber) {
            logo
            name
            isRTPEnabled
        }
    }
`

gql`
    mutation AddBankAccount($createAccountInput: CreateAccountInput!) {
        createCheckbookAccount(createAccountInput: $createAccountInput) {
            ...FullBankAccount
        }
    }
    ${BANK_ACCOUNT_FRAGMENT}
`

gql`
    mutation DeleteBankAccount($accountId: String!) {
        deleteCheckbookAccount(accountId: $accountId) {
            ...FullBankAccount
        }
    }
    ${BANK_ACCOUNT_FRAGMENT}
`

gql`
    mutation RenameBankAccount($accountId: String!, $name: String!) {
        renameCheckbookAccount(accountId: $accountId, name: $name) {
            ...FullBankAccount
        }
    }
    ${BANK_ACCOUNT_FRAGMENT}
`
